export const getMonthIndexByDayIndex = (
  dayIndex: number,
  monthHeaders: { startIndex: number; days: number }[],
) => {
  for (let i = 0; i < monthHeaders.length; i++) {
    const { startIndex, days } = monthHeaders[i];
    if (dayIndex >= startIndex && dayIndex < startIndex + days) {
      return i;
    }
  }

  if (
    monthHeaders.length > 0 &&
    dayIndex >= monthHeaders[monthHeaders.length - 1].startIndex
  ) {
    return monthHeaders.length - 1;
  }

  return -1;
};
